import api from '../api';

export async function getAllPublicTrips(userId) {
    const response = await api.get(`/public/trips/all/${userId}`);
    return response.data;
}

export async function getSinglePublicTrip(userId, tripId) {
    const response = await api.get(`/public/trips/${tripId}/${userId}`);
    return response.data;
}